import React, { useEffect } from 'react'
import styled from 'styled-components'

// components
import Row from '../../../components/Row'
import LaunchErr from './LaunchErr'
import ProgressWrapper from './ProgressWrapper'
import DPlayer from 'dplayer'
import { ButtonConfirmed } from '../../../components/Button'

const LaunchRow = styled(Row)<{ right?: string }>`
  flex-direction: column;
  align-items: center;
  margin-right: ${({right}) => right ? right : '0px'};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 10px;
  `}
`
const LaunchImgRow = styled(LaunchRow)`
  width: 262px;
  height: 370px;
`
const LaunchImg = styled(LaunchImgRow)`
  position: relative;
  width: 260px;
  .cover {
    transition: opacity 0.2s linear;
    opacity: 0;
  }
  &:hover {
    .cover {
      opacity: 1;
    }
  }
  .video .dplayer-controller {
    height: 0!important;
    overflow: hidden;
  }
  .aplayer {
    margin: 0;
    // display: flex;
    // align-items: center;
    justify-content: center;
  }
  .aplayer-body {
    width: 100%;
  }
`
const BgCover = styled.img`
  width: 262px;
  height: 348px;
  cursor: pointer;
`
const CurImage = styled.img`
  width: 260px;
  height: 346px;
  border-radius: 10px;
`
const CurPlayer = styled.div`
  width: 260px;
  height: 346px;
  border-radius: 10px;
`
const HoverCover = styled.div<{bg?: string}>`
  position: absolute;
  width: 261px;
  height: 347px;
  background-image: url(${({ bg }) => bg});
  cursor: pointer;
  border-radius: 10px;
  background-size: cover;
`
const Button = styled(ButtonConfirmed)`
  margin: 5px 0 13px;
  border: none;
  font-size: 14px;
  width: 244px;
  height: 40px;
  border-radius: 10px;
  padding: 0;
`
const SupportMp3 = styled.div`
  font-family: Yuanti SC;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${({theme}) => theme.bsText3};
`

export interface Info {
  text: string
  err: string
  errShow: boolean
  placeholder: string
  file?: string
  format?: string
  progressBar: {
    show: boolean,
    progress: number
  }
}

export default function UpLoadFiles({info, bgCover, hoverCover, fileType, uploadImg, right, cancelUpload}: {info: Info, bgCover: string, hoverCover: string, fileType: number, uploadImg: any, right?: string, cancelUpload?: () => void}) {
  useEffect(() => {
    if (info.file && document.getElementById('curPlayer') && fileType === 3) {
      new DPlayer({
        container: document.getElementById('curPlayer'),
        autoplay: false,
        video: {
          url: info.file,
          type: info.format ? info.format : 'auto'
        }
      })
    }
  }, [info.file, info.format, fileType])

  return (
    <>
      <LaunchRow right={right}>
        {
          fileType !== 4 ?
            info.file ?
              <LaunchImg>
              {
                fileType !== 3 ? (
                  <CurImage src={info.file} alt=""/>
                ) : <CurPlayer id="curPlayer" className="video"></CurPlayer>
              }
              <HoverCover className="cover" bg={hoverCover} onClick={uploadImg}></HoverCover>
              <LaunchErr errShow={info.errShow} text={info.err}></LaunchErr>
            </LaunchImg> :
            <LaunchImgRow>
              <BgCover src={bgCover} alt="" onClick={uploadImg}></BgCover>
              <LaunchErr errShow={info.errShow} text={info.err}></LaunchErr>
            </LaunchImgRow>
          : <></>
        }
        {
          fileType === 4 && <div style={{textAlign: 'center'}}>
            <LaunchErr errShow={info.errShow} text={info.err}></LaunchErr>
            <Button onClick={uploadImg}>Upload Audio</Button>
            <SupportMp3>( Support: mp3 )</SupportMp3>
          </div>
        }
        {
          info.progressBar.show && <ProgressWrapper show={info.progressBar.show} progress={info.progressBar.progress} cancelUpload={cancelUpload}></ProgressWrapper>
        }
      </LaunchRow>
    </>
  )
}
